module.exports = __webpack_public_path__ + "img/logo.e53fc03d.png";